export default __webpack_public_path__ + "static/media/insurancebrokerage.0bf97499.png";